import {Injectable} from "@angular/core";
import {
  DirectMessageIssueDto,
  DirectMessageIssuePreviewDto,
  IssueType,
  MessageIssueDto,
  SubmitDirectMessageIssueDto
} from "@server-models";
import {FormGroup} from "@angular/forms";
import {SharedIssueStereotypeBaseService} from "@shared/components/issues/services/stereotype/shared-issue-stereotype-base.service";
import {TCurrentIssueDto} from "../types/issue-dto.type";
import {ILocalIssueDetailData} from "@shared/components/issues/interfaces/local-issue-detail-data.interface";
import {Store} from "@ngrx/store";
import {IAdditionalDetails} from "@shared/components/issues/interfaces/additional-details.interface";

@Injectable({
  providedIn: 'root',
})
export class SharedIssueDirectMessageService extends SharedIssueStereotypeBaseService {

  override formatReadDetailData(issueDtoType: TCurrentIssueDto, issueType: IssueType): ILocalIssueDetailData {
    const directMessageIssueDto = issueDtoType as DirectMessageIssueDto;
    return {
      ...this.formatBaseReadDetailData(directMessageIssueDto, issueType),
      additionalDetails: { ...this.getAdditionalFormattedData(directMessageIssueDto) }
    };
  }

  prepareFormIssueDto(formGroup: FormGroup,
                      templatePreviewDto: DirectMessageIssuePreviewDto): SubmitDirectMessageIssueDto {
    return {
      ...formGroup.value,
      issueId: 0,
      title: formGroup.value?.title ?? templatePreviewDto.name,
    };
  }

  override getAdditionalFormattedData(issueDto: TCurrentIssueDto): Partial<IAdditionalDetails> {
    const issue = issueDto as DirectMessageIssueDto;
    return {
      location: issue.location,
      resource: issue.resource,
      locations: issue.locationReceivers,
      contacts: issue.contactReceivers
    }
  }
}
